import React from 'react'
import Select from 'react-select';
import { useRecoilState, useRecoilValue } from 'recoil';
import { selectedTagsState } from '../state/selectedTagsState';
import { tagsState } from '../state/tagsState';

export const SelectTag = () => {

    const tags = useRecoilValue(tagsState);
    const [, setSelectedTags] = useRecoilState(selectedTagsState);

    const customStyles = {
        menu: (provided, state) => ({
            ...provided,
            width: state.selectProps.width,
            color: state.selectProps.menuColor,
            padding: 20,
        }),

        control: (provided, state ) => ({
            ...provided,
            boxShadow: "none",
            width: "100%",
            position: "relative",
            border: 'none',
            margin: 0,
            height: '50px',
            borderRadius: "12px 0 0 12px",
            "&:hover":  {
                background: "#EBEBEB"
              }
        }),

		valueContainer: (provided, state) => ({
			...provided,
			flexWrap: 'nowrap',
		}),

        singleValue: (provided, state) => {
            const opacity = state.isDisabled ? 0.5 : 1;
            const transition = 'opacity 300ms';

            return { ...provided, opacity, transition };
        },
    };

    return (
        <Select
            id="post-type"
            styles={customStyles}
            placeholder="Seleziona categoria"
            onChange={(value => setSelectedTags(value.map(item => Number(item.value))))}
            closeMenuOnSelect={false}
            isMulti
            options={tags}
        />
    )
}
